import { render, staticRenderFns } from "./AddImport.vue?vue&type=template&id=23aeebca&scoped=true&"
import script from "./AddImport.vue?vue&type=script&lang=js&"
export * from "./AddImport.vue?vue&type=script&lang=js&"
import style0 from "./AddImport.vue?vue&type=style&index=0&id=23aeebca&prod&scoped=true&lang=css&"
import style1 from "./AddImport.vue?vue&type=style&index=1&id=23aeebca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aeebca",
  null
  
)

export default component.exports